import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useComposerContext
} from "../../context";
import type {
    LucideIcon
} from "lucide-react-native";
import {
    CircleStop as CircleStopIcon,
    Paperclip as PaperclipIcon,
    ArrowUp as ArrowUpIcon,
    WifiOff as WifiOffIcon,
    Info as InfoIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";

const getComposerIcon = (Icon: LucideIcon): NCoreUIKitIcon => {
    const ComposerIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => {
        const {
            colors
        } = NCoreUIKitTheme.useContext();

        return <Icon
            color={customColor ?? colors.content.icon[color]}
            size={size}
        />;
    };

    return ComposerIcon;
};

export const ComposerPaperclipIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const context = useComposerContext();

    return <AnimatedIcon
        customTheme={context?.customTheme}
        customColor={customColor}
        animationTrigger="hover"
        animation="signature"
        icon={PaperclipIcon}
        color={color}
        size={size}
    />;
};

export const ComposerSubmitIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const context = useComposerContext();

    return <AnimatedIcon
        isTransitioned={!!context?.isStreaming}
        customTheme={context?.customTheme}
        customColor={customColor}
        toIcon={CircleStopIcon}
        fromIcon={ArrowUpIcon}
        iconTransition="morph"
        color={color}
        size={size}
    />;
};

export const ComposerWifiOffIcon = getComposerIcon(WifiOffIcon);

export const ComposerInfoIcon = getComposerIcon(InfoIcon);
